/**
 * Helpers para filtrado y resolución de nombres en traspasos
 */
import CatalogUtils from "../../../utils/CatalogUtils";

/**
 * Verifica si un traspaso coincide con la búsqueda de texto
 * Busca en cabecera y líneas del traspaso
 */
export const matchesTextSearch = (traspaso, searchText, almacenes, empleados) => {
    if (!searchText) return true;

    const fields = [
        traspaso.id,
        traspaso.almacenOrigen,
        traspaso.almacenDestino,
        CatalogUtils.getNombreAlmacen(traspaso.almacenOrigen, almacenes),
        CatalogUtils.getNombreAlmacen(traspaso.almacenDestino, almacenes),
        CatalogUtils.getNombreEmpleado(traspaso.empleadoOrigenId, empleados),
        CatalogUtils.getNombreEmpleado(traspaso.empleadoDestinoId, empleados),
        traspaso.observaciones,
        traspaso.estado,
    ];

    const headerMatch = fields.some((f) => CatalogUtils.textIncludes(f, searchText));
    if (headerMatch) return true;

    // Buscar en líneas
    return (traspaso.lineas ?? []).some((l) =>
        [l.codigoArticulo, l.nombre, l.barras].some((f) => CatalogUtils.textIncludes(f, searchText))
    );
};

/**
 * Verifica si un traspaso coincide con el filtro de almacén
 * Busca en origen O destino
 */
export const matchesAlmacenFilter = (traspaso, almacenFilter) => {
    if (!almacenFilter) return true;
    const alm = String(almacenFilter).padStart(2, "0");
    return String(traspaso.almacenOrigen).padStart(2, "0") === alm ||
           String(traspaso.almacenDestino).padStart(2, "0") === alm;
};

/**
 * Verifica si un traspaso coincide con el filtro de empleado
 * Busca en origen O destino
 */
export const matchesEmpleadoFilter = (traspaso, empleadoFilter) => {
    if (!empleadoFilter) return true;
    const empId = String(empleadoFilter);
    return String(traspaso.empleadoOrigenId) === empId ||
           String(traspaso.empleadoDestinoId) === empId;
};

/**
 * Enriquece un traspaso con nombres resueltos
 */
export const enrichTraspasoWithNames = (traspaso, almacenes, empleados) => ({
    ...traspaso,
    almacenOrigenNombre: CatalogUtils.getNombreAlmacen(traspaso.almacenOrigen, almacenes),
    almacenDestinoNombre: CatalogUtils.getNombreAlmacen(traspaso.almacenDestino, almacenes),
    empleadoOrigenNombre: CatalogUtils.getNombreEmpleado(traspaso.empleadoOrigenId, empleados),
    empleadoDestinoNombre: CatalogUtils.getNombreEmpleado(traspaso.empleadoDestinoId, empleados),
});

/**
 * Aplica filtros del lado del cliente a un array de traspasos
 */
export const applyClientFilters = (rows, filtros, almacenes, empleados) => {
    let filtered = rows;

    // Filtro por almacén (origen o destino)
    if (filtros.almacen) {
        filtered = filtered.filter((r) => matchesAlmacenFilter(r, filtros.almacen));
    }

    // Filtro por empleado (origen o destino)
    if (filtros.empleado) {
        filtered = filtered.filter((r) => matchesEmpleadoFilter(r, filtros.empleado));
    }

    // Filtro por búsqueda de texto
    if (filtros.q) {
        filtered = filtered.filter((r) => matchesTextSearch(r, filtros.q, almacenes, empleados));
    }

    // Enriquecer con nombres resueltos
    return filtered.map((r) => enrichTraspasoWithNames(r, almacenes, empleados));
};
